import { createFileRoute } from '@tanstack/react-router';
import { ExpiryView } from '../../expiry/expiry-view.js';

export const Route = createFileRoute('/_station/expiry')({
  component: ExpiryView,
});
